/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useState } from "react";
import FileUploadSection from "../Common/FileUploadSection/FileUploadSection";
import TextContainer from "../../Container/TextContainer";
import Paper from "@mui/material/Paper";
import ButtonLoading from "../../Button/ButtonLoading";
import { useNavigate } from "react-router";
import documentStyle from "./documentStyle";
import { getCaseLink } from "../../../services/productService";
import { useForm } from "../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";
import useMediaObjectCombinationRequest from "../../../hooks/useMediaObjectCombinationRequest";
import LegalbirdLoader from "../../ContentLoader/LegalbirdLoader";

type DocumentsProps = {
  product: AbstractCase;
};

const Documents = ({ product }: DocumentsProps) => {
  let mediaObjectCombinationRequestTypes = ["contractFiles", "contractTerminationFiles"];

  const { mediaObjectCombinationRequests, isLoadingMediaObjectCombinationRequest, updateAction, hasAtLeastOneFileOfType } = useMediaObjectCombinationRequest(
    product,
    mediaObjectCombinationRequestTypes
  );

  const navigate = useNavigate();
  const [isBlocked, setIsBlocked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit } = useForm();

  const isComplete = () => {
    return (
      hasAtLeastOneFileOfType(mediaObjectCombinationRequests, "contractFiles") &&
      hasAtLeastOneFileOfType(mediaObjectCombinationRequests, "contractTerminationFiles")
    );
  };

  const handleSubmitInternal = async (event: React.FormEvent<HTMLFormElement>) => {
    setIsLoading(true);
    await handleSubmit(event, { preventRedirect: true });
    navigate(getCaseLink(product));
  };

  if (isLoadingMediaObjectCombinationRequest) {
    return <LegalbirdLoader />;
  }

  return (
    <Paper elevation={4}>
      <TextContainer>
        <Box sx={documentStyle.inlineHintBox}>
          <Typography variant={"h5"} sx={documentStyle.headline}>
            Wichtig
          </Typography>
          Laden Sie hier Ihr Dokument als Bild oder PDF hoch, oder fotografieren Sie es einfach ab. Bitte beachten Sie dabei, dass alles gut erkennbar und
          nichts abgeschnitten ist. Benutzen Sie bestenfalls beim Fotografieren den Blitz.
        </Box>
        <FileUploadSection
          mediaObjectCombinationRequest={mediaObjectCombinationRequests.contractFiles}
          temporaryMediaObjectsFieldname={"contractFiles"}
          headline={"Arbeitsvertrag"}
          helperText={
            "Bitte laden Sie Ihren vollständigen Arbeitsvertrag hoch. Sie können hier mehrere Seiten hochladen. Bitte achten Sie darauf, dass alle Seiten des Vertrages vorliegen."
          }
          productEntity={product}
          productEntityId={product.id}
          product={"settlement"}
          updateAction={updateAction}
          setIsBlocked={setIsBlocked}
          isBlocked={isBlocked}
          fieldName={"contract"}
        />
        <FileUploadSection
          mediaObjectCombinationRequest={mediaObjectCombinationRequests.contractTerminationFiles}
          temporaryMediaObjectsFieldname={"contractTerminationFiles"}
          headline={"Kündigung"}
          helperText={"Bitte laden Sie hier das Kündigungsschreiben hoch."}
          productEntity={product}
          productEntityId={product.id}
          product={"settlement"}
          updateAction={updateAction}
          setIsBlocked={setIsBlocked}
          isBlocked={isBlocked}
          fieldName={"contractTermination"}
        />
        <ButtonLoading
          sx={documentStyle.uploadButton}
          color="primary"
          variant="contained"
          disabled={!isComplete()}
          fullWidth={true}
          onClick={handleSubmitInternal}
          isLoading={isLoading}
          loadingText={"Fall wird angelegt"}
        >
          Jetzt abschicken
        </ButtonLoading>
      </TextContainer>
    </Paper>
  );
};
export default Documents;
